module.exports = __webpack_public_path__ + "img/woyaoyou_head_defult@2x.1bb12f44.png";